export default __webpack_public_path__ + "static/media/length.dcb8da8f.svg";